import React, { useState } from 'react';

const sections = [
  {
    title: 'About the artwork',
    content: [
      'Each piece is a hand-painted original, crafted by skilled artists using premium paints on high-quality canvas. No prints or copies—just one-of-a-kind artwork with a signed Certificate of Authenticity.',
    ],
  },
  {
    title: 'Shipping',
    content: [
      'Artworks are securely packed and shipped with care. Processing takes 3–7 business days, and delivery is estimated between 5–10 business days. Tracking is shared once shipped. International shipping is available to select countries.',
    ],
  },
  {
    title: 'Cancellations & Returns',
    content: [
      'Orders can be cancelled within 24 hours. Since each piece is unique, returns aren’t accepted unless the artwork arrives damaged. If so, contact us within 48 hours with photos for support.',
    ],
  },
];

const Collapsehandpaintings = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleSection = (index) => {
    setOpenIndex(prev => (prev === index ? null : index));
  };

  return (
    <div className="w-full max-w-4xl mx-auto px-4 py-6">
      {sections.map((section, index) => {
        const isOpen = openIndex === index;

        return (
          <div key={index} className="mb-4 border border-gray-300 rounded-lg overflow-hidden shadow-sm">
            <button
              onClick={() => toggleSection(index)}
              className="w-full flex items-center justify-between px-4 py-3 bg-gray-100 hover:bg-gray-200 text-left transition-colors duration-200 font-serif"
            >
              <span>{section.title}</span>
              <span className={`transform transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}>
                ▼
              </span>
            </button>

            <div
              className={`transition-max-height duration-500 ease-in-out overflow-hidden ${
                isOpen ? 'max-h-[1000px]' : 'max-h-0'
              } bg-white`}
            >
              <div className="px-4 py-3">
                <ul className="list-disc list-inside space-y-2 text-gray-700 text-base sm:text-base">
                  {section.content.map((line, i) => (
                    <li key={i}>{line}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Collapsehandpaintings;
